import { AutoEscalateType } from "@avenueops/shared-types";
import { SmartForm, TextInputTypes } from "@avenueops/web-components";
import { AutoEscalateTimePeriod } from "@prisma/client";
import React from "react";
import { useWatch } from "react-hook-form";

interface Props {
  namePrefix: string;
  required?: boolean;
}

export default function AutoEscalatePicker({ namePrefix, required }: Props): JSX.Element {
  const timePeriod = useWatch({ name: `${namePrefix}.timePeriod` });
  const isAutoEscalate = timePeriod !== "NEVER";

  return (
    <div className="flex flex-col w-full">
      <div className="px-4 pt-2 pb-4 w-full bg-gray-50 text-sm font-semibold border-t-0 rounded-b border mx-auto text-gray-500 flex flex-row items-center">
        <span className="w-52"> {`Automatically escalate ${isAutoEscalate ? "after" : ""}`}</span>
        <div className="flex flex-row gap-x-2 items-end w-1/2">
          {isAutoEscalate ? (
            <div className="w-1/3">
              <SmartForm.TextInput name={`${namePrefix}.quantity`} placeholder="#" type={TextInputTypes.NUMBER} />
            </div>
          ) : null}

          <div className="w-1/3">
            <SmartForm.DropdownSelect
              name={`${namePrefix}.timePeriod`}
              options={[
                ...Object.keys(AutoEscalateTimePeriod).map((timePeriodKey) => ({
                  label: timePeriodKey.toLowerCase(),
                  value: AutoEscalateTimePeriod[timePeriodKey as AutoEscalateTimePeriod],
                })),
                // If required, don't allow the user to select "never"
                ...(required
                  ? []
                  : [
                      {
                        label: "never",
                        value: "NEVER",
                      },
                    ]),
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
